import { useQuery } from '@tanstack/react-query';

import parseServerError from '../../helpers/parseServerError';
import notificationService from '../../notifications/notificationService';
import { QueryKeys } from '../../query.client';
import invitationsService from '../../services/invitation/invitations.service';

export function useInvitationDetailsQuery(invitationId?: string) {
  const { refetch, isFetching, isLoading, data } = useQuery({
    enabled: !!invitationId,
    queryKey: [
      { entity: QueryKeys.INVITATION_DETAILS, id: invitationId, withPreRegistrationInfo: true, withCreator: true },
    ],
    queryFn: async () =>
      invitationsService.getInvitation(invitationId!, { withPreRegistrationInfo: true, withCreator: true }),
    onError: (error: any) =>
      notificationService.addNotification({
        message: parseServerError(error),
        variant: 'danger',
      }),
  });

  return {
    refetchInvitation: refetch,
    isFetchingInvitation: isFetching,
    isLoadingInvitation: isLoading,
    invitationInfo: data,
  };
}
